import { configureStore } from '@reduxjs/toolkit';
import experimentReducer from "./ExperimentSlice";
import issuesReducer from './IssuesSlice';

const experimentStore = configureStore({
    reducer: {
      experiments: experimentReducer,
      issues: issuesReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
      }),
});

export default experimentStore;